import React from 'react';
import { useTranslation } from "react-i18next";

import { capitalize, getObjectWithJsonDataToFormValues } from '../../libraries/utils';
import Avatar from '../../components/commons/Avatar';


export default function PharmacyCard ({ pharmacy, ...rest }) {
  const { t, i18n } = useTranslation();

  const { logo_picture, name, address } = getObjectWithJsonDataToFormValues(
    pharmacy,
    ['id', 'logo_picture', 'name', 'address']
  );

  return (
    <div className="card white mb-3 p-4 h-full"
      onClick={rest.onClick && rest.onClick}
    >
      <div className="text-center m-auto">
        <Avatar
          image={logo_picture}
          label={capitalize(name)}
          className="rounded-full w-16 h-16"
          containerClassName="mb-3 justify-center"
        />
        <h4 className="text-primary m-auto">{capitalize(name)}</h4>
        <p>{address.direccion}</p>
        <small className="text-gray-500">1.0km</small>
      </div>
    </div>
  )
}
  